export default __webpack_public_path__ + "static/media/f2a615ebee4c1af79fd11fee020aa5a6.jpg";